// Generated by scripts/import-overwatch-sprays.mjs. Edit tools/overwatch/heroes.json.
export const importedChampions = [
  {
    "name": "Lifeweaver",
    "compValue": "lifeweaver"
  },
  {
    "name": "Illari",
    "compValue": "illari"
  },
  {
    "name": "Mauga",
    "compValue": "mauga"
  },
  {
    "name": "Venture",
    "compValue": "venture"
  },
  {
    "name": "Juno",
    "compValue": "juno"
  },
  {
    "name": "Hazard",
    "compValue": "hazard"
  },
  {
    "name": "Freja",
    "compValue": "freja"
  },
  {
    "name": "Wuyang",
    "compValue": "wuyang"
  },
  {
    "name": "Vendetta",
    "compValue": "vendetta"
  },
  {
    "name": "Domina",
    "compValue": "domina"
  },
  {
    "name": "Emre",
    "compValue": "emre"
  },
  {
    "name": "Anran",
    "compValue": "anran"
  },
  {
    "name": "Mizuki",
    "compValue": "mizuki"
  },
  {
    "name": "Jetpack Cat",
    "compValue": "jetpackcat"
  },
  {
    "name": "Sierra",
    "compValue": "sierra"
  },
  {
    "name": "Shion",
    "compValue": "shion"
  },
  {
    "name": "D.Mon",
    "compValue": "dmon"
  },
  {
    "name": "Doctrine",
    "compValue": "doctrine"
  }
];

export const importedPixel = [
  {
    "id": "lifeweaver",
    "type": "head",
    "num": 38,
    "imgurl": "pixelmixer/heads/lifeweaver_head.png",
    "suffix": "Life",
    "width": 163,
    "height": 176,
    "headanchorx": 56,
    "headanchory": 130,
    "leganchorx": null,
    "leganchory": null
  },
  {
    "id": "lifeweaver",
    "type": "torso",
    "num": 38,
    "imgurl": "pixelmixer/torsos/lifeweaver_torso.png",
    "suffix": "wea",
    "width": 330,
    "height": 370,
    "headanchorx": 136,
    "headanchory": 175,
    "leganchorx": 134,
    "leganchory": 268
  },
  {
    "id": "lifeweaver",
    "type": "legs",
    "num": 38,
    "imgurl": "pixelmixer/legs/lifeweaver_legs.png",
    "suffix": "ver",
    "width": 78,
    "height": 147,
    "headanchorx": null,
    "headanchory": null,
    "leganchorx": 42,
    "leganchory": 0
  },
  {
    "id": "illari",
    "type": "head",
    "num": 39,
    "imgurl": "pixelmixer/heads/illari_head.png",
    "suffix": "Il",
    "width": 440,
    "height": 216,
    "headanchorx": 232,
    "headanchory": 178,
    "leganchorx": null,
    "leganchory": null
  },
  {
    "id": "illari",
    "type": "torso",
    "num": 39,
    "imgurl": "pixelmixer/torsos/illari_torso.png",
    "suffix": "la",
    "width": 446,
    "height": 229,
    "headanchorx": 252,
    "headanchory": 1,
    "leganchorx": 233,
    "leganchory": 103
  },
  {
    "id": "illari",
    "type": "legs",
    "num": 39,
    "imgurl": "pixelmixer/legs/illari_legs.png",
    "suffix": "ri",
    "width": 122,
    "height": 135,
    "headanchorx": null,
    "headanchory": null,
    "leganchorx": 55,
    "leganchory": 0
  },
  {
    "id": "mauga",
    "type": "head",
    "num": 40,
    "imgurl": "pixelmixer/heads/mauga_head.png",
    "suffix": "Ma",
    "width": 206,
    "height": 117,
    "headanchorx": 69,
    "headanchory": 107,
    "leganchorx": null,
    "leganchory": null
  },
  {
    "id": "mauga",
    "type": "torso",
    "num": 40,
    "imgurl": "pixelmixer/torsos/mauga_torso.png",
    "suffix": "u",
    "width": 462,
    "height": 193,
    "headanchorx": 203,
    "headanchory": 32,
    "leganchorx": 202,
    "leganchory": 137
  },
  {
    "id": "mauga",
    "type": "legs",
    "num": 40,
    "imgurl": "pixelmixer/legs/mauga_legs.png",
    "suffix": "ga",
    "width": 185,
    "height": 112,
    "headanchorx": null,
    "headanchory": null,
    "leganchorx": 91,
    "leganchory": 0
  },
  {
    "id": "venture",
    "type": "head",
    "num": 41,
    "imgurl": "pixelmixer/heads/venture_head.png",
    "suffix": "Ven",
    "width": 180,
    "height": 122,
    "headanchorx": 93,
    "headanchory": 115,
    "leganchorx": null,
    "leganchory": null
  },
  {
    "id": "venture",
    "type": "torso",
    "num": 41,
    "imgurl": "pixelmixer/torsos/venture_torso.png",
    "suffix": "t",
    "width": 375,
    "height": 174,
    "headanchorx": 158,
    "headanchory": 10,
    "leganchorx": 147,
    "leganchory": 122
  },
  {
    "id": "venture",
    "type": "legs",
    "num": 41,
    "imgurl": "pixelmixer/legs/venture_legs.png",
    "suffix": "ure",
    "width": 220,
    "height": 83,
    "headanchorx": null,
    "headanchory": null,
    "leganchorx": 112,
    "leganchory": 0
  },
  {
    "id": "juno",
    "type": "head",
    "num": 42,
    "imgurl": "pixelmixer/heads/juno_head.png",
    "suffix": "Ju",
    "width": 112,
    "height": 111,
    "headanchorx": 50,
    "headanchory": 109,
    "leganchorx": null,
    "leganchory": null
  },
  {
    "id": "juno",
    "type": "torso",
    "num": 42,
    "imgurl": "pixelmixer/torsos/juno_torso.png",
    "suffix": "n",
    "width": 316,
    "height": 323,
    "headanchorx": 176,
    "headanchory": 161,
    "leganchorx": 178,
    "leganchory": 201
  },
  {
    "id": "juno",
    "type": "legs",
    "num": 42,
    "imgurl": "pixelmixer/legs/juno_legs.png",
    "suffix": "o",
    "width": 156,
    "height": 143,
    "headanchorx": null,
    "headanchory": null,
    "leganchorx": 66,
    "leganchory": 0
  },
  {
    "id": "hazard",
    "type": "head",
    "num": 43,
    "imgurl": "pixelmixer/heads/hazard_head.png",
    "suffix": "Ha",
    "width": 149,
    "height": 132,
    "headanchorx": 65,
    "headanchory": 128,
    "leganchorx": null,
    "leganchory": null
  },
  {
    "id": "hazard",
    "type": "torso",
    "num": 43,
    "imgurl": "pixelmixer/torsos/hazard_torso.png",
    "suffix": "z",
    "width": 504,
    "height": 348,
    "headanchorx": 322,
    "headanchory": 140,
    "leganchorx": 272,
    "leganchory": 241
  },
  {
    "id": "hazard",
    "type": "legs",
    "num": 43,
    "imgurl": "pixelmixer/legs/hazard_legs.png",
    "suffix": "ard",
    "width": 231,
    "height": 119,
    "headanchorx": null,
    "headanchory": null,
    "leganchorx": 152,
    "leganchory": 0
  },
  {
    "id": "freja",
    "type": "head",
    "num": 44,
    "imgurl": "pixelmixer/heads/freja_head.png",
    "suffix": "Fr",
    "width": 201,
    "height": 121,
    "headanchorx": 149,
    "headanchory": 117,
    "leganchorx": null,
    "leganchory": null
  },
  {
    "id": "freja",
    "type": "torso",
    "num": 44,
    "imgurl": "pixelmixer/torsos/freja_torso.png",
    "suffix": "e",
    "width": 328,
    "height": 204,
    "headanchorx": 201,
    "headanchory": 53,
    "leganchorx": 178,
    "leganchory": 117
  },
  {
    "id": "freja",
    "type": "legs",
    "num": 44,
    "imgurl": "pixelmixer/legs/freja_legs.png",
    "suffix": "ja",
    "width": 116,
    "height": 95,
    "headanchorx": null,
    "headanchory": null,
    "leganchorx": 66,
    "leganchory": 0
  },
  {
    "id": "wuyang",
    "type": "head",
    "num": 45,
    "imgurl": "pixelmixer/heads/wuyang_head.png",
    "suffix": "Wu",
    "width": 99,
    "height": 142,
    "headanchorx": 58,
    "headanchory": 139,
    "leganchorx": null,
    "leganchory": null
  },
  {
    "id": "wuyang",
    "type": "torso",
    "num": 45,
    "imgurl": "pixelmixer/torsos/wuyang_torso.png",
    "suffix": "ya",
    "width": 228,
    "height": 246,
    "headanchorx": 134,
    "headanchory": 79,
    "leganchorx": 126,
    "leganchory": 138
  },
  {
    "id": "wuyang",
    "type": "legs",
    "num": 45,
    "imgurl": "pixelmixer/legs/wuyang_legs.png",
    "suffix": "ng",
    "width": 185,
    "height": 114,
    "headanchorx": null,
    "headanchory": null,
    "leganchorx": 83,
    "leganchory": 0
  },
  {
    "id": "vendetta",
    "type": "head",
    "num": 46,
    "imgurl": "pixelmixer/heads/vendetta_head.png",
    "suffix": "Ven",
    "width": 179,
    "height": 162,
    "headanchorx": 60,
    "headanchory": 160,
    "leganchorx": null,
    "leganchory": null
  },
  {
    "id": "vendetta",
    "type": "torso",
    "num": 46,
    "imgurl": "pixelmixer/torsos/vendetta_torso.png",
    "suffix": "det",
    "width": 352,
    "height": 227,
    "headanchorx": 125,
    "headanchory": 124,
    "leganchorx": 121,
    "leganchory": 195
  },
  {
    "id": "vendetta",
    "type": "legs",
    "num": 46,
    "imgurl": "pixelmixer/legs/vendetta_legs.png",
    "suffix": "ta",
    "width": 156,
    "height": 109,
    "headanchorx": null,
    "headanchory": null,
    "leganchorx": 77,
    "leganchory": 0
  },
  {
    "id": "domina",
    "type": "head",
    "num": 47,
    "imgurl": "pixelmixer/heads/domina_head.png",
    "suffix": "Do",
    "width": 149,
    "height": 122,
    "headanchorx": 63,
    "headanchory": 116,
    "leganchorx": null,
    "leganchory": null
  },
  {
    "id": "domina",
    "type": "torso",
    "num": 47,
    "imgurl": "pixelmixer/torsos/domina_torso.png",
    "suffix": "mi",
    "width": 485,
    "height": 329,
    "headanchorx": 221,
    "headanchory": 111,
    "leganchorx": 221,
    "leganchory": 226
  },
  {
    "id": "domina",
    "type": "legs",
    "num": 47,
    "imgurl": "pixelmixer/legs/domina_legs.png",
    "suffix": "na",
    "width": 52,
    "height": 98,
    "headanchorx": null,
    "headanchory": null,
    "leganchorx": 24,
    "leganchory": 0
  },
  {
    "id": "emre",
    "type": "head",
    "num": 48,
    "imgurl": "pixelmixer/heads/emre_head.png",
    "suffix": "Em",
    "width": 112,
    "height": 139,
    "headanchorx": 63,
    "headanchory": 138,
    "leganchorx": null,
    "leganchory": null
  },
  {
    "id": "emre",
    "type": "torso",
    "num": 48,
    "imgurl": "pixelmixer/torsos/emre_torso.png",
    "suffix": "r",
    "width": 444,
    "height": 166,
    "headanchorx": 203,
    "headanchory": 55,
    "leganchorx": 186,
    "leganchory": 136
  },
  {
    "id": "emre",
    "type": "legs",
    "num": 48,
    "imgurl": "pixelmixer/legs/emre_legs.png",
    "suffix": "e",
    "width": 220,
    "height": 117,
    "headanchorx": null,
    "headanchory": null,
    "leganchorx": 102,
    "leganchory": 0
  },
  {
    "id": "anran",
    "type": "head",
    "num": 49,
    "imgurl": "pixelmixer/heads/anran_head.png",
    "suffix": "An",
    "width": 172,
    "height": 204,
    "headanchorx": 45,
    "headanchory": 156,
    "leganchorx": null,
    "leganchory": null
  },
  {
    "id": "anran",
    "type": "torso",
    "num": 49,
    "imgurl": "pixelmixer/torsos/anran_torso.png",
    "suffix": "r",
    "width": 264,
    "height": 220,
    "headanchorx": 117,
    "headanchory": 88,
    "leganchorx": 129,
    "leganchory": 159
  },
  {
    "id": "anran",
    "type": "legs",
    "num": 49,
    "imgurl": "pixelmixer/legs/anran_legs.png",
    "suffix": "an",
    "width": 156,
    "height": 81,
    "headanchorx": null,
    "headanchory": null,
    "leganchorx": 93,
    "leganchory": 0
  },
  {
    "id": "mizuki",
    "type": "head",
    "num": 50,
    "imgurl": "pixelmixer/heads/mizuki_head.png",
    "suffix": "Mi",
    "width": 231,
    "height": 142,
    "headanchorx": 112,
    "headanchory": 137,
    "leganchorx": null,
    "leganchory": null
  },
  {
    "id": "mizuki",
    "type": "torso",
    "num": 50,
    "imgurl": "pixelmixer/torsos/mizuki_torso.png",
    "suffix": "zu",
    "width": 300,
    "height": 197,
    "headanchorx": 148,
    "headanchory": 50,
    "leganchorx": 142,
    "leganchory": 111
  },
  {
    "id": "mizuki",
    "type": "legs",
    "num": 50,
    "imgurl": "pixelmixer/legs/mizuki_legs.png",
    "suffix": "ki",
    "width": 152,
    "height": 110,
    "headanchorx": null,
    "headanchory": null,
    "leganchorx": 66,
    "leganchory": 0
  },
  {
    "id": "jetpackcat",
    "type": "head",
    "num": 51,
    "imgurl": "pixelmixer/heads/jetpackcat_head.png",
    "suffix": "Jet",
    "width": 114,
    "height": 104,
    "headanchorx": 52,
    "headanchory": 102,
    "leganchorx": null,
    "leganchory": null
  },
  {
    "id": "jetpackcat",
    "type": "torso",
    "num": 51,
    "imgurl": "pixelmixer/torsos/jetpackcat_torso.png",
    "suffix": "pack ",
    "width": 324,
    "height": 192,
    "headanchorx": 178,
    "headanchory": 122,
    "leganchorx": 166,
    "leganchory": 162
  },
  {
    "id": "jetpackcat",
    "type": "legs",
    "num": 51,
    "imgurl": "pixelmixer/legs/jetpackcat_legs.png",
    "suffix": "Cat",
    "width": 122,
    "height": 110,
    "headanchorx": null,
    "headanchory": null,
    "leganchorx": 78,
    "leganchory": 0
  },
  {
    "id": "sierra",
    "type": "head",
    "num": 52,
    "imgurl": "pixelmixer/heads/sierra_head.png",
    "suffix": "Si",
    "width": 216,
    "height": 246,
    "headanchorx": 52,
    "headanchory": 127,
    "leganchorx": null,
    "leganchory": null
  },
  {
    "id": "sierra",
    "type": "torso",
    "num": 52,
    "imgurl": "pixelmixer/torsos/sierra_torso.png",
    "suffix": "er",
    "width": 423,
    "height": 235,
    "headanchorx": 286,
    "headanchory": 77,
    "leganchorx": 279,
    "leganchory": 137
  },
  {
    "id": "sierra",
    "type": "legs",
    "num": 52,
    "imgurl": "pixelmixer/legs/sierra_legs.png",
    "suffix": "ra",
    "width": 163,
    "height": 121,
    "headanchorx": null,
    "headanchory": null,
    "leganchorx": 106,
    "leganchory": 0
  },
  {
    "id": "shion",
    "type": "head",
    "num": 53,
    "imgurl": "pixelmixer/heads/shion_head.png",
    "suffix": "Sh",
    "width": 144,
    "height": 155,
    "headanchorx": 59,
    "headanchory": 102,
    "leganchorx": null,
    "leganchory": null
  },
  {
    "id": "shion",
    "type": "torso",
    "num": 53,
    "imgurl": "pixelmixer/torsos/shion_torso.png",
    "suffix": "i",
    "width": 324,
    "height": 266,
    "headanchorx": 120,
    "headanchory": 62,
    "leganchorx": 122,
    "leganchory": 148
  },
  {
    "id": "shion",
    "type": "legs",
    "num": 53,
    "imgurl": "pixelmixer/legs/shion_legs.png",
    "suffix": "on",
    "width": 236,
    "height": 128,
    "headanchorx": null,
    "headanchory": null,
    "leganchorx": 114,
    "leganchory": 0
  },
  {
    "id": "dmon",
    "type": "head",
    "num": 54,
    "imgurl": "pixelmixer/heads/dmon_head.png",
    "suffix": "D.",
    "width": 244,
    "height": 196,
    "headanchorx": 71,
    "headanchory": 192,
    "leganchorx": null,
    "leganchory": null
  },
  {
    "id": "dmon",
    "type": "torso",
    "num": 54,
    "imgurl": "pixelmixer/torsos/dmon_torso.png",
    "suffix": "M",
    "width": 512,
    "height": 284,
    "headanchorx": 251,
    "headanchory": 144,
    "leganchorx": 291,
    "leganchory": 185
  },
  {
    "id": "dmon",
    "type": "legs",
    "num": 54,
    "imgurl": "pixelmixer/legs/dmon_legs.png",
    "suffix": "on",
    "width": 208,
    "height": 131,
    "headanchorx": null,
    "headanchory": null,
    "leganchorx": 91,
    "leganchory": 0
  },
  {
    "id": "doctrine",
    "type": "head",
    "num": 55,
    "imgurl": "pixelmixer/heads/doctrine_head.png",
    "suffix": "Doc",
    "width": 158,
    "height": 150,
    "headanchorx": 111,
    "headanchory": 145,
    "leganchorx": null,
    "leganchory": null
  },
  {
    "id": "doctrine",
    "type": "torso",
    "num": 55,
    "imgurl": "pixelmixer/torsos/doctrine_torso.png",
    "suffix": "tr",
    "width": 405,
    "height": 450,
    "headanchorx": 218,
    "headanchory": 180,
    "leganchorx": 210,
    "leganchory": 247
  },
  {
    "id": "doctrine",
    "type": "legs",
    "num": 55,
    "imgurl": "pixelmixer/legs/doctrine_legs.png",
    "suffix": "ine",
    "width": 124,
    "height": 183,
    "headanchorx": null,
    "headanchory": null,
    "leganchorx": 65,
    "leganchory": 0
  }
];

export const importedCute = [
  {
    "id": "lifeweaver",
    "type": "head",
    "num": 38,
    "imgurl": "cutemixer/heads/lifeweaver_head.png",
    "suffix": "Life",
    "width": 308,
    "height": 273,
    "headanchorx": 174,
    "headanchory": 272
  },
  {
    "id": "lifeweaver",
    "type": "torso",
    "num": 38,
    "imgurl": "cutemixer/torsos/lifeweaver_torso.png",
    "suffix": "weaver",
    "width": 349,
    "height": 260,
    "headanchorx": 244,
    "headanchory": 81
  },
  {
    "id": "illari",
    "type": "head",
    "num": 39,
    "imgurl": "cutemixer/heads/illari_head.png",
    "suffix": "Illa",
    "width": 322,
    "height": 375,
    "headanchorx": 135,
    "headanchory": 285
  },
  {
    "id": "illari",
    "type": "torso",
    "num": 39,
    "imgurl": "cutemixer/torsos/illari_torso.png",
    "suffix": "ri",
    "width": 283,
    "height": 164,
    "headanchorx": 176,
    "headanchory": 18
  },
  {
    "id": "mauga",
    "type": "head",
    "num": 40,
    "imgurl": "cutemixer/heads/mauga_head.png",
    "suffix": "Mau",
    "width": 441,
    "height": 364,
    "headanchorx": 172,
    "headanchory": 340
  },
  {
    "id": "mauga",
    "type": "torso",
    "num": 40,
    "imgurl": "cutemixer/torsos/mauga_torso.png",
    "suffix": "ga",
    "width": 349,
    "height": 160,
    "headanchorx": 187,
    "headanchory": 37
  },
  {
    "id": "venture",
    "type": "head",
    "num": 41,
    "imgurl": "cutemixer/heads/venture_head.png",
    "suffix": "Ven",
    "width": 397,
    "height": 252,
    "headanchorx": 175,
    "headanchory": 248
  },
  {
    "id": "venture",
    "type": "torso",
    "num": 41,
    "imgurl": "cutemixer/torsos/venture_torso.png",
    "suffix": "ture",
    "width": 348,
    "height": 252,
    "headanchorx": 155,
    "headanchory": 57
  },
  {
    "id": "juno",
    "type": "head",
    "num": 42,
    "imgurl": "cutemixer/heads/juno_head.png",
    "suffix": "Ju",
    "width": 338,
    "height": 306,
    "headanchorx": 172,
    "headanchory": 301
  },
  {
    "id": "juno",
    "type": "torso",
    "num": 42,
    "imgurl": "cutemixer/torsos/juno_torso.png",
    "suffix": "no",
    "width": 490,
    "height": 410,
    "headanchorx": 240,
    "headanchory": 281
  },
  {
    "id": "hazard",
    "type": "head",
    "num": 43,
    "imgurl": "cutemixer/heads/hazard_head.png",
    "suffix": "Haz",
    "width": 320,
    "height": 336,
    "headanchorx": 190,
    "headanchory": 335
  },
  {
    "id": "hazard",
    "type": "torso",
    "num": 43,
    "imgurl": "cutemixer/torsos/hazard_torso.png",
    "suffix": "ard",
    "width": 493,
    "height": 366,
    "headanchorx": 268,
    "headanchory": 242
  },
  {
    "id": "freja",
    "type": "head",
    "num": 44,
    "imgurl": "cutemixer/heads/freja_head.png",
    "suffix": "Fre",
    "width": 412,
    "height": 281,
    "headanchorx": 125,
    "headanchory": 279
  },
  {
    "id": "freja",
    "type": "torso",
    "num": 44,
    "imgurl": "cutemixer/torsos/freja_torso.png",
    "suffix": "ja",
    "width": 394,
    "height": 196,
    "headanchorx": 135,
    "headanchory": 63
  },
  {
    "id": "wuyang",
    "type": "head",
    "num": 45,
    "imgurl": "cutemixer/heads/wuyang_head.png",
    "suffix": "Wu",
    "width": 283,
    "height": 327,
    "headanchorx": 120,
    "headanchory": 324
  },
  {
    "id": "wuyang",
    "type": "torso",
    "num": 45,
    "imgurl": "cutemixer/torsos/wuyang_torso.png",
    "suffix": "yang",
    "width": 264,
    "height": 182,
    "headanchorx": 116,
    "headanchory": 10
  },
  {
    "id": "vendetta",
    "type": "head",
    "num": 46,
    "imgurl": "cutemixer/heads/vendetta_head.png",
    "suffix": "Ven",
    "width": 401,
    "height": 304,
    "headanchorx": 114,
    "headanchory": 301
  },
  {
    "id": "vendetta",
    "type": "torso",
    "num": 46,
    "imgurl": "cutemixer/torsos/vendetta_torso.png",
    "suffix": "detta",
    "width": 316,
    "height": 274,
    "headBehindTorso": true,
    "headanchorx": 52,
    "headanchory": 135
  },
  {
    "id": "domina",
    "type": "head",
    "num": 47,
    "imgurl": "cutemixer/heads/domina_head.png",
    "suffix": "Domi",
    "width": 358,
    "height": 316,
    "headanchorx": 184,
    "headanchory": 276
  },
  {
    "id": "domina",
    "type": "torso",
    "num": 47,
    "imgurl": "cutemixer/torsos/domina_torso.png",
    "suffix": "na",
    "width": 385,
    "height": 232,
    "headanchorx": 198,
    "headanchory": 48
  },
  {
    "id": "emre",
    "type": "head",
    "num": 48,
    "imgurl": "cutemixer/heads/emre_head.png",
    "suffix": "Em",
    "width": 280,
    "height": 306,
    "headanchorx": 155,
    "headanchory": 301
  },
  {
    "id": "emre",
    "type": "torso",
    "num": 48,
    "imgurl": "cutemixer/torsos/emre_torso.png",
    "suffix": "re",
    "width": 237,
    "height": 178,
    "headanchorx": 175,
    "headanchory": 23
  },
  {
    "id": "anran",
    "type": "head",
    "num": 49,
    "imgurl": "cutemixer/heads/anran_head.png",
    "suffix": "An",
    "width": 466,
    "height": 367,
    "headanchorx": 147,
    "headanchory": 364
  },
  {
    "id": "anran",
    "type": "torso",
    "num": 49,
    "imgurl": "cutemixer/torsos/anran_torso.png",
    "suffix": "ran",
    "width": 392,
    "height": 177,
    "headanchorx": 130,
    "headanchory": 88
  },
  {
    "id": "mizuki",
    "type": "head",
    "num": 50,
    "imgurl": "cutemixer/heads/mizuki_head.png",
    "suffix": "Mizu",
    "width": 430,
    "height": 297,
    "headanchorx": 203,
    "headanchory": 292
  },
  {
    "id": "mizuki",
    "type": "torso",
    "num": 50,
    "imgurl": "cutemixer/torsos/mizuki_torso.png",
    "suffix": "ki",
    "width": 335,
    "height": 126,
    "headanchorx": 152,
    "headanchory": 22
  },
  {
    "id": "jetpackcat",
    "type": "head",
    "num": 51,
    "imgurl": "cutemixer/heads/jetpackcat_head.png",
    "suffix": "Jetpack ",
    "width": 280,
    "height": 290,
    "headanchorx": 140,
    "headanchory": 287
  },
  {
    "id": "jetpackcat",
    "type": "torso",
    "num": 51,
    "imgurl": "cutemixer/torsos/jetpackcat_torso.png",
    "suffix": "Cat",
    "width": 394,
    "height": 320,
    "headanchorx": 249,
    "headanchory": 155
  },
  {
    "id": "sierra",
    "type": "head",
    "num": 52,
    "imgurl": "cutemixer/heads/sierra_head.png",
    "suffix": "Sier",
    "width": 408,
    "height": 413,
    "headanchorx": 193,
    "headanchory": 315
  },
  {
    "id": "sierra",
    "type": "torso",
    "num": 52,
    "imgurl": "cutemixer/torsos/sierra_torso.png",
    "suffix": "ra",
    "width": 259,
    "height": 197,
    "headanchorx": 188,
    "headanchory": 58
  },
  {
    "id": "shion",
    "type": "head",
    "num": 53,
    "imgurl": "cutemixer/heads/shion_head.png",
    "suffix": "Shi",
    "width": 328,
    "height": 287,
    "headanchorx": 171,
    "headanchory": 286
  },
  {
    "id": "shion",
    "type": "torso",
    "num": 53,
    "imgurl": "cutemixer/torsos/shion_torso.png",
    "suffix": "on",
    "width": 331,
    "height": 231,
    "headanchorx": 138,
    "headanchory": 67
  },
  {
    "id": "dmon",
    "type": "head",
    "num": 54,
    "imgurl": "cutemixer/heads/dmon_head.png",
    "suffix": "D.",
    "width": 321,
    "height": 278,
    "headanchorx": 174,
    "headanchory": 238
  },
  {
    "id": "dmon",
    "type": "torso",
    "num": 54,
    "imgurl": "cutemixer/torsos/dmon_torso.png",
    "suffix": "Mon",
    "width": 412,
    "height": 439,
    "headanchorx": 94,
    "headanchory": 308
  },
  {
    "id": "doctrine",
    "type": "head",
    "num": 55,
    "imgurl": "cutemixer/heads/doctrine_head.png",
    "suffix": "Doc",
    "width": 286,
    "height": 267,
    "headanchorx": 145,
    "headanchory": 266
  },
  {
    "id": "doctrine",
    "type": "torso",
    "num": 55,
    "imgurl": "cutemixer/torsos/doctrine_torso.png",
    "suffix": "trine",
    "width": 476,
    "height": 447,
    "headBehindTorso": true,
    "headanchorx": 169,
    "headanchory": 293
  }
];
